import type { TareaArtifact } from '@/lib/types'
import { IconFile, IconEdit, IconGlobe, IconExternalLink } from '@/components/icons/Icons'

interface Props {
  artifacts: TareaArtifact[]
  onViewArtifact?: (artifact: TareaArtifact) => void
}

function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

function ArtifactIcon({ tipo }: { tipo: TareaArtifact['tipo'] }) {
  switch (tipo) {
    case 'archivo':    return <IconFile size={16} />
    case 'canvas':     return <IconEdit size={16} />
    case 'google_doc': return <IconGlobe size={16} />
  }
}

function metaLabel(artifact: TareaArtifact): string {
  switch (artifact.tipo) {
    case 'archivo':
      return artifact.size_bytes ? formatSize(artifact.size_bytes) : 'Archivo'
    case 'canvas':
      return 'Texto'
    case 'google_doc':
      return 'Google Doc'
  }
}

export default function TareaArtifacts({ artifacts, onViewArtifact }: Props) {
  if (!artifacts || artifacts.length === 0) return null

  const handleClick = (artifact: TareaArtifact) => {
    switch (artifact.tipo) {
      case 'archivo':
        if (artifact.url) window.open(artifact.url, '_blank', 'noopener')
        break
      case 'canvas':
        onViewArtifact?.(artifact)
        break
      case 'google_doc':
        if (artifact.google_doc_url) window.open(artifact.google_doc_url, '_blank', 'noopener')
        break
    }
  }

  return (
    <div className="artifact-list">
      {artifacts.map((a) => (
        <button
          key={a.id}
          type="button"
          className="artifact-item"
          onClick={() => handleClick(a)}
          title={a.nombre}
        >
          <span className={`artifact-item__icon artifact-item__icon--${a.tipo}`}>
            <ArtifactIcon tipo={a.tipo} />
          </span>
          <span className="artifact-item__info">
            <span className="artifact-item__name">{a.nombre}</span>
            <span className="artifact-item__meta">{metaLabel(a)}</span>
          </span>
          {(a.tipo === 'archivo' || a.tipo === 'google_doc') && (
            <span className="artifact-item__external">
              <IconExternalLink size={12} />
            </span>
          )}
        </button>
      ))}
    </div>
  )
}
